import { Component, OnInit, Input } from '@angular/core';
import { UserInfo } from '../userInfo';
import { DataService } from '../dataService.service';



@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.css']
})
export class ContactDetailsComponent implements OnInit {


  @Input() UserInfos:UserInfo;
  public mapsData;
 
  // private lUrl = "https://maps.google.com/maps?q=Sri+Lakshmi+Venkateshwara+enterprises/@14.223428,76.3999771,16z/data=!4m8!1m2!2m1!1ssri+lakshmi+venkateshwara+enterprises+chitradurga!3m4!1s0x3bba755a4158597b:0xf8528953f5a7ef10!8m2!3d14.2166061!4d76.4048424&ie=UTF8&iwloc=&output=embed";
  constructor(private dataService: DataService ) {


   }

  ngOnInit() {

  }
  checkiFrame_load(){

    let iFame_temp = document.getElementById("1_maps")
  }

 
  ngOnChanges(UserInfos:any, UserInfo: any){
   if(this.UserInfos && this.UserInfos.Address ){
   //document.getElementById("1_maps").setAttribute("src", this.UserInfos.locationUrl);

   (<HTMLIFrameElement>document.getElementById("1_maps")).src= this.UserInfos.locationUrl;
    //this.lurl = this.sanitizer.bypassSecurityTrustResourceUrl(this.UserInfos.locationUrl)
    //  this.dataService.getStoreLocation().subscribe(data=>{
    //   this.mapsData=data;
    //  },err =>{

    //  });;
   }
  }

}
